import React from "react";
import {
  FaSmile,
  FaUserFriends,
  FaMapMarkedAlt,
  FaClock,
} from "react-icons/fa";

const RADIUS = 32;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const stats = [
  {
    id: 1,
    Icon: FaSmile,
    label: "BIRTHS REGISTERED",
    value: "8,450,000",
    trend: "+12.5k this week",
    liveData: true,
    type: "number",
    textColor: "#006B3F",
  },
  {
    id: 2,
    Icon: FaUserFriends,
    label: "ACTIVE REGISTRARS",
    value: "12,500",
    subLabel: "4,820 Active Centers",
    type: "number",
  },
  {
    id: 3,
    Icon: FaMapMarkedAlt,
    label: "PARTICIPATING STATES",
    value: "37",
    subLabel: "36 States + FCT",
    type: "number",
  },
  {
    id: 4,
    label: "NATIONAL TARGET",
    title: "Achievement",
    percentage: 68,
    trend: "+5% from last month",
    type: "donut",
  },
];

function NumberCard({ item }) {
  const { Icon, label, value, trend, subLabel, liveData, textColor } = item;
  return (
    <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
      <div className="flex items-center justify-between mb-3">
        <div
          className="rounded-lg p-2 flex items-center justify-center"
          style={{ background: "#A3F1BF" }}
        >
          <Icon style={{ color: "#006B3F", fontSize: "18px" }} />
        </div>
        {liveData && (
          <div
            className="flex items-center gap-1 font-semibold"
            style={{
              color: "#2e7d32",
              background: "#e8f5e9",
              padding: "2px 6px",
              borderRadius: "12px",
              fontSize: "10px",
            }}
          >
            <span
              className="inline-block rounded-full"
              style={{
                width: "7px",
                height: "7px",
                background: "#2e7d32",
              }}
            />
            LIVE DATA
          </div>
        )}
      </div>

      <p
        className="text-xs font-medium tracking-wider mb-1 mt-0"
        style={{ color: "#3E4A41" }}
      >
        {label}
      </p>
      <p
        className="font-bold  leading-none mb-1 mt-0"
        style={{ fontSize: "48px", color: textColor || "#1A1C1E" }}
      >
        {value}
      </p>
      {trend && (
        <p
          className="text-xs mb-0 mt-0"
          style={{ color: textColor || "#16a34a" }}
        >
          ↗ {trend}
        </p>
      )}
      {subLabel && (
        <p
          className="text-xs mb-0 mt-0"
          style={{ color: textColor || "#616363" }}
        >
          {subLabel}
        </p>
      )}
    </div>
  );
}

function DonutCard({ item }) {
  const { label, title, percentage, trend } = item;
  const filled = (percentage / 100) * CIRCUMFERENCE;
  const gap = CIRCUMFERENCE - filled;
  return (
    <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 flex items-center gap-4">
      <svg width="90" height="90" viewBox="0 0 80 80" className="flex-shrink-0">
        <circle
          cx="40"
          cy="40"
          r={RADIUS}
          fill="none"
          stroke="#f3f4f6"
          strokeWidth="10"
        />
        <circle
          cx="40"
          cy="40"
          r={RADIUS}
          fill="none"
          stroke="#f97316"
          strokeWidth="10"
          strokeDasharray={`${filled} ${gap}`}
          strokeLinecap="round"
          transform="rotate(-90 40 40)"
        />
        <text
          x="40"
          y="45"
          textAnchor="middle"
          fontSize="14"
          fontWeight="bold"
          fill="#111827"
        >
          {percentage}%
        </text>
      </svg>
      <div>
        <p
          className="text-xs font-medium tracking-wider mb-1 mt-0"
          style={{ color: "#3E4A41" }}
        >
          {label}
        </p>
        <p
          className="font-bold leading-tight mb-1 mt-0"
          style={{ fontSize: "22px", color: "#1A1C1E" }}
        >
          {title}
        </p>
        <p className="text-xs mb-0 mt-0" style={{ color: "#006B3F" }}>
          ↗ {trend}
        </p>
      </div>
    </div>
  );
}

export default function Stats() {
  return (
    <div className="px-4 md:px-6 pt-4 pb-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-3">
        {stats.map((item) =>
          item.type === "donut" ? (
            <DonutCard key={item.id} item={item} />
          ) : (
            <NumberCard key={item.id} item={item} />
          ),
        )}
      </div>
      <p className="text-xs text-gray-400 flex items-center gap-1 mb-0 mt-0">
        <FaClock />
        Last Updated: Today, 10:45 AM WAT
      </p>
    </div>
  );
}
